import { storage } from '~/common/utils/storage';
import axios from '~/common/plugins/axios.js'
export const state = () => ({
  loginFlag: false,
  loginDioShow: false,
  registBeforeRoute: '',
  afterRouteLoginOpen: false, // 是否在路由后立即打开登录弹层，注意：使用后需要离开 设置为true
  registHeader: {},
  userProfile: {
    // 可在此配置默认项
    avatar: '',
    real_name: '',
    user_name: '',
    registration_at: '',
    last_login_at: '',
    phone: '',
    email: '',
    logo: '',
    timezone_id: '',
    latest_shop_id: '',
    latest_shop_name: '',
    personal_shop_id: '',
    timezone: '',
    language_id: '',
    language: ''
  },
  // 圈子
  userShops: [],
  shopId: '',
  waifang:false,
  slugDatas:{},
  shopMessageDetail:{}
});

export const mutations = {
  set_loginFlag(state, v) {
    state.loginFlag = v;
    if(process.client) {
      sessionStorage.setItem('loginFlag', v)
    }
  },
  set_loginDioShow(state, v) {
    state.loginDioShow = v;
  },
  set_registHeader(state, v) {
    state.registHeader = v;
  },
  set_userProfile(state, v) {
    state.userProfile = v;
  },
  set_afterRouteLoginOpen(state, v) {
    state.afterRouteLoginOpen = v;
  },
  set_registBeforeRoute(state, v) {
    state.registBeforeRoute = v;
  },
  set_userShops(state, v) {
    state.userShops = v;
  },
  set_userShopId(state, v) {
    state.shopId = v;
  },
  set_waifang(state, v) {
    state.waifang = v;
  },
  set_slugDatas(state, v) {
    state.slugDatas = v;
  },
  set_shopMessageDetail(state, v) {
    state.shopMessageDetail = v;
  }
};
const getters = {
  get_loginFlag() {
    if(process.client) {
      return sessionStorage.getItem('loginFlag')
    } else {
      return false
    }
  }
}
export const actions = {
  async get_userProfile({ commit }) {
    const userProfile = await axios.$get('/rest/store/contact/v3/users/traits');
    if (userProfile && userProfile.data) {
      userProfile.data.auth.erp = {
        ...userProfile.data.auth.erp,
        ...{
          // operation: {
          //   department: {
          //     bn: {
          //       list: true
          //     }
          //   },
          //   attendance: {
          //     shift_schedule: {
          //       list: true
          //     },
          //     setting: {
          //       list: true
          //     },
          //     unusual_routine: {
          //       list: true
          //     },
          //     record: {
          //       list: true
          //     },
          //     application_form: {
          //       list: true
          //     },
          //     report: {
          //       list: true
          //     }
          //   }
          // }
        }
      };
      const { latest_shop_slug, latest_shop_url_slug } = userProfile.data
      userProfile.data.latest_shop_slug = latest_shop_url_slug ? latest_shop_url_slug : latest_shop_slug
      commit('set_userProfile', userProfile.data);
      commit('set_userShopId', userProfile.data.latest_shop_id);
      if (process.client) {
        storage.set('profile', userProfile.data);
      }
      return userProfile;
    }
  },
  async get_token({ commit }, params) {
    if (!storage.get('session_token')) return false;
    const tokenInfo = await axios.$get(`/rest/store/contact/v3/flows?action=${params.type}`);
    return tokenInfo;
  },
  async get_regist_token({ commit }, params) {
    const tokenInfo = await axios.$get(`/ory/self-service/browser/flows/requests/registration?request=${params.requestId}`);
    return tokenInfo;
  },
  async get_login_token({ commit }, params) {
    const tokenInfo = await axios.$get(`/ory/self-service/browser/flows/requests/login?request=${params.requestId}`);
    return tokenInfo;
  },
  async post_registration_checkcode({ commit }, params) {
    // 校验注册验证码
    const res = await axios.$post(`/rest/store/contact/v3/registration/checkcode`, params, {
      headers: {
        showNotify: false
      }
    });
    return res;
  },
  // 获取公钥
  async getPublicKey ({ commit }) {
    const res = await axios.$get(`/rest/store/contact/v3/public`);
    return res
  },
  // 获取登录验证码
  async getLoginVerifyCode({ commit }, params) {
    const res = await axios.$post(`/rest/store/contact/v3/login/vcode/send`, params)
    return res
  },
  // 短信验证码登录
  async verifyCodeLogin({ commit }, params) {
    const res = await axios.$post(`/api/connection/v1/login`, params)
    return res
  },
  async post_regist({ commit }, params) {
    let headers = {}
    if(params['X-Session-Token']) {
      //需要添加token
      headers['X-Session-Token'] = params['X-Session-Token']
      delete params['X-Session-Token']
    }
    if(params['has_no_token']) {
      //强制删除token
      headers['has_no_token'] = params['has_no_token']
      delete params['has_no_token']
    }
    let formData = new FormData();
    for (let key in params) {
      formData.append(key, params[key]);
    } 
    const res = await axios.$post(`/api/portal/v1/auth/register`, params, {headers});
    return res;
  },
  async company_name_valid({ commit }, params) {
    const res = await axios.$post(`/rest/store/contact/v3/contactshop/checkjoin`, {
      name: params
    });
    return res;
  },
  async post_login({ commit }, params) {
    const res = await axios.$post(`/rest/store/contact/v3/sessions`, params);
    return res;
  },
  async put_newpwd({ commit }, params) {
    const res = await axios.$put(`/rest/store/contact/v3/users/password`, params);
    return res;
  },
  async post_newpwd({ commit }, params) {
    const res = await axios.$post(`/rest/store/contact/v3/users/password`, params);
    return res;
  },
  async post_registration_code({ commit }, params) {
    const res = await axios.$post(`/rest/store/contact/v3/registration/code`, params);
    return res;
  },
  async post_forgetpwd_code({ commit }, params) {
    const res = await axios.$post(`/rest/store/contact/v3/forgetpwd/code`, params);
    return res;
  },
  async post_forgetpwd_checkcode({ commit }, params) {
    // 校验忘记密码
    const res = await axios.$post(`/rest/store/contact/v3/forgetpwd/checkcode`, params);
    return res;
  },
  async get_registration_contract({ commit }, params) {
    // 获取注册合约
    const res = await axios.$post(`/rest/store/hub/v3/registerText/HubContractTextByAccountType`, params);
    return res;
  },
  async get_captcha_id({ commit }) {
    // 图形验证码id hash ipfs
    const res = await axios.$get(`/rest/store/contact/v3/captcha/id`);
    if (res.data && res.data.id) {
      return {
        ts: new Date().getTime(), // 当前时间戳
        id: res.data.id,
        url: `/rest/store/contact/v3/captcha?id=${res.data.id}`
      };
    } else return null;
  },
  async get_captcha_img({ commit }, params) {
    // 图形验图片链接 - 弃用
    // todo ipfs ip端口 应该使用config配置 固定写法：http://192.168.1.60:9052/connection/v1/captcha?id=${params.id}
    return `/rest/store/contact/v3/captcha?id=${params.id}`;
  },
  async get_userShops({ commit, state }, params) {
    const res = await axios.$post('/rest/store/contact/v3/contactshopsidnamelist', {
      page_index: 1,
      page_size: params.page_size
    });
    if (!res || (res && res.code !== 200)) return false;

    const { code, data } = res;

    if (code !== 200) return { code, data };
    commit('set_userShops', data.list);

    return data.list;
  },
  async patch_shop({ commit, dispatch }, params) {
    // 切换圈子
    const res = await axios.$patch(`/rest/store/contact/v3/users/updateshopid`, params);

    // 保存用户圈子选择
    // commit('set_userShopId', params.shop_id);
    await dispatch('get_userProfile');
    return res;
  }
};
export default {
	namespaced: true,
	state,
	actions,
	mutations,
  getters
}
